import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import ScopedCssBaseline from "@mui/material/ScopedCssBaseline";
import { InputComponentProps } from "components/Form/components/InputComponentProps";
import { Icon } from "components/Icon/Icon";
import { IconCollection } from "components/Icon/IconCollection";
import { Ref, useState } from "react";
import { isBlank } from "utils/valueTransformers";

export interface PasswordProps {
    name: string;
    attributes?: any; // TODO consider improvement
    touched: boolean;
    errorMessage: string;
    input: InputComponentProps<string>;
    preventAutofill?: boolean;
    inputRef?: Ref<any>;
}

export const Password = ({
    name,
    attributes,
    touched,
    errorMessage,
    input,
    preventAutofill = false,
    inputRef,
}: PasswordProps) => {
    const [passwordVisible, setPasswordVisible] = useState(false);

    const handleClickShowPassword = () => {
        setPasswordVisible(!passwordVisible);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const value = input.value == null ? "" : input.value;
    return (
        <ScopedCssBaseline>
            <FormControl variant="outlined" className="inputField">
                <OutlinedInput
                    {...attributes}
                    {...input}
                    value={value}
                    aria-label={name}
                    error={touched && !isBlank(errorMessage)}
                    type={passwordVisible ? "text" : "password"}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                                <Icon
                                    icon={
                                        passwordVisible
                                            ? IconCollection.eyeOffOutline
                                            : IconCollection.eyeOutline
                                    }
                                />
                            </IconButton>
                        </InputAdornment>
                    }
                    autoComplete={preventAutofill ? "new-password" : undefined}
                    inputRef={inputRef}
                    inputProps={{ autoComplete: preventAutofill ? "new-password" : undefined }}
                />
            </FormControl>
        </ScopedCssBaseline>
    );
};
